import { React, useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import choose_image_1 from '../../images/Industries/micro-landing/dynamic_inventory.png'
import choose_image_2 from '../../images/Industries/micro-landing/data_driven.png'
import choose_image_3 from '../../images/Industries/micro-landing/feasibility.png'
import choose_image_4 from '../../images/Industries/micro-landing/occupational_services.png'
import Button from '../Button';
import FormModal from '../FormModal';



function Whyus() {

    // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    function toggle() {
        setModalToggle(!modalToggle);
    }

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const chooseus = [
        {
            src: choose_image_1,
            alt: "Dynamic_Inventory_icon",
            heading: "Dynamic Inventory",
            content: " Access a curated collection of unlisted properties not available on the open market.",

        },
        {
            src: choose_image_2,
            alt: "Data driven",
            heading: "Data driven",
            content: " Every location choice is anchored in real-time market data and insights",

        },
        {
            src: choose_image_3,
            alt: "Feasibility",
            heading: "Feasibility",
            content: "Smart evaluation of what fits your business goals and budget.",

        },
        {
            src: choose_image_4,
            alt: "Occupational services",
            heading: "Occupational services",
            content: "Workspace fit-outs and setups designed to get you operational faster.",

        },

    ]
    return (
        <>
            {/* Why Choose us */}
            <div className="mt-10 pb-[125px] max-w-full mx-auto bg-grey py-[80px]" data-aos="fade-up">
                <h1 className='heading'>Why work with us?</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' />

                <div className="max-w-[1278px] mx-auto flex flex-wrap justify-between gap-y-10 mt-[40px] md:mt-[70px] px-2" data-aos="fade-up">
                    {
                        chooseus.map((items) => {
                            return (

                                <div className='w-[294px] h-fit sm:h-[398px] mx-auto bg-white shadow-md py-[40px] px-[20px] sm:pt-[70px]' data-aos="fade-up">
                                    <img className="w-[60px] h-[60px] mx-auto sm:w-[50px] sm:h-[50px]" src={items.src} alt={items.alt} />

                                    <div className='max-w-[215px] mx-auto mt-[35px] text-center'>
                                        <h2 className="text-[24px] font-noto leading-[40px] font-bold sm:text-[26px]">{items.heading}</h2>
                                        <p className="font-alibaba text-[18px] text-[#5F5D5E] leading-[26px] font-normal mt-[20px]">{items.content}</p>
                                    </div>

                                </div>

                            )
                        })}
                </div>

                <div className='flex justify-center mt-[85px]'>
                    <Button
                        name={"Work With Us"}
                        design={"filled"}
                        action={"modal-open"}
                        modalfunction={toggle}
                    />
                </div>

            </div>

            <FormModal
                modal={modalToggle}
                active={toggle}
            />
        </>
    );
}

export default Whyus;